<script lang="ts">
    import type { PrefixedRoute } from "@frontend/routes";
    export let href: PrefixedRoute;
</script>

<a href="{href}" {...$$restProps}><slot /></a>